export const sentryComponentName = {
    LOGIN: "signin",
    BRAND_SELECT: "BrandSelect",
    MAIN: "Main"
}